import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { TelefoneService } from '../../../services';

@Component({
    templateUrl: 'telefone.edit.component.html',
})

export class TelefoneEditComponent extends DetalheBaseController {

    model: any = {};

    constructor(route: ActivatedRoute, private _telefoneService: TelefoneService) {
        super(route, _telefoneService);                
    }

    public salvar(form) {
        let type = this._route.snapshot.data['type'];
        if (type == "edit") {            
            form.id = this.model.id;
            this.subPut = this.service.putId(this.service._api, this.model.id, form).subscribe(result => {
                localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.registroSalvoComSucesso") + '!');
                this._location.back();
            });
        } else {            
            this.model.Telefone = this.model.Telefone.replace(/\D/g, '');
            this.model.Ddd = this.model.Telefone.slice(0, 2);
            this.model.Numero = this.model.Telefone.slice(2, this.model.Telefone.length);
            form.Ddd = this.model.Ddd;
            form.Numero = this.model.Numero;
            this.subPost = this.service.post(this.service._api, form).subscribe(result => {
                localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.registroSalvoComSucesso") + '!');
                this._location.back();
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/telefone/edit/telefone.edit.component.ts